import translate from "@deosite/helpers/langLibrary";
import React, { useEffect, useRef } from "react";
import Container from "@commerce-ui/core2/Container";
import Box from "@commerce-ui/core2/Box";
import MenuItemsList from "../../sections/MenuItemsList";
import PageContainer from "../../containers/UI/PageContainer";
import Grid from "@commerce-ui/core2/Grid";
import SectionWithConfigurableHeader from "../../sections/SectionWithConfigurableHeader";

const BrandsListPage = ({
  title,
  menuItems,
  backLabel,
  backClickFunction,
  footerContent,
  dataRequiredToHideLoader
}) => {
  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title")
  };

  const splitBrandsMenu = () => {
    let splitMenu = [];
    let element;
    let arrayLength = menuItems?.length || 0;
    let partSize = 10;

    for (element = 0, arrayLength; element < arrayLength; element += partSize) {
      let arrayPart = menuItems.slice(element, element + partSize);
      splitMenu.push(arrayPart);
    }
    return splitMenu;
  };

  const brandsMenu = menuItems ? splitBrandsMenu() : false;

  return (
    <PageContainer
      footerContent={footerContent}
      returnLinkLabel={backLabel}
      onReturnLabelClick={backClickFunction}
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      dataRequiredToHideLoader={dataRequiredToHideLoader}
    >
      <SectionWithConfigurableHeader title={title}>
        <Container>
          <Grid cols={[1, null, null, 20]}>
            {Array.isArray(brandsMenu) &&
              brandsMenu?.map((menu, index) => {
                return (
                  <Box
                    sx={{
                      gridColumn: ["span 1", null, "span 5", null],
                      mt: index > 0 ? ["-9px", null, 0, null] : 0
                    }}
                    key={index}
                  >
                    <MenuItemsList menuItems={menu} />
                  </Box>
                );
              })}
          </Grid>
        </Container>
      </SectionWithConfigurableHeader>
    </PageContainer>
  );
};

export default BrandsListPage;
